import { boltApi } from 'store/queries/bolt-api'
import {
  GetPriceHistoryPayload,
  GetPriceHistoryResponse,
  GetYearOverviewMetricsPayload,
  GetYearOverviewMetricsResponse,
  PriceHistoryType
} from './types.ts'
import dayjs from 'dayjs'
import { stringify } from 'qs'
import { Response } from 'types/request'
import { Flow } from 'types/logging.ts'
import { ISO8601_DATE_FORMAT } from 'constants/constants.ts'
import { createErrorTransformer } from 'store/queries/utils.ts'

export const metricsBoltApi = boltApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET PRICE HISTORY
    getPriceHistory: builder.query<GetPriceHistoryResponse, GetPriceHistoryPayload>({
      query: ({ granularity, from, until, unit, type }) => {
        const fromFormatted = dayjs(from).format(ISO8601_DATE_FORMAT)
        const untilFormatted = dayjs(until).format(ISO8601_DATE_FORMAT)

        return {
          url: `/metrics/price-history?granularity=${granularity}&from=${fromFormatted}&until=${untilFormatted}&unit=${unit || 'MWh'}&type=${type || PriceHistoryType.PRICE}`
        }
      },
      transformResponse: ({ data }) => {
        return data
      },
      transformErrorResponse: createErrorTransformer(`[${Flow.METRICS}:getPriceHistory]`)
    }),

    // GET YEAR OVERVIEW METRICS
    getYearOverviewMetrics: builder.query<GetYearOverviewMetricsResponse | null, GetYearOverviewMetricsPayload>({
      query: ({ email, billingContractNumber }) => {
        const query = stringify(
          { email, billingContractNumber },
          {
            skipNulls: true,
            addQueryPrefix: true,
            encodeValuesOnly: true
          }
        )

        return {
          url: `/metrics/year-overview${query}`
        }
      },
      transformResponse: ({ success, data }: Response<GetYearOverviewMetricsResponse>) => (success && data ? data : null),
      transformErrorResponse: createErrorTransformer(`[${Flow.METRICS}:getYearOverviewMetrics]`)
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPriceHistoryQuery, useGetYearOverviewMetricsQuery } = metricsBoltApi
